export default __webpack_public_path__ + "static/media/avatar.82e023cf.jpg";